var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckcircleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15371 6.33451C3.25217 6.23609 3.38568 6.1808 3.52489 6.1808C3.6641 6.1808 3.79761 6.23609 3.89606 6.33451L5.75246 8.19091L9.46421 4.47864C9.51296 4.42986 9.57083 4.39116 9.63453 4.36475C9.69823 4.33834 9.76651 4.32473 9.83546 4.32471C9.90442 4.32468 9.97271 4.33824 10.0364 4.36461C10.1001 4.39097 10.158 4.42963 10.2068 4.47838C10.2556 4.52712 10.2943 4.58499 10.3207 4.64869C10.3471 4.71239 10.3607 4.78067 10.3608 4.84963C10.3608 4.91859 10.3472 4.98687 10.3209 5.05059C10.2945 5.11431 10.2558 5.17221 10.2071 5.22099L6.24744 9.18064C5.97407 9.45401 5.53085 9.45401 5.25749 9.18064L3.15371 7.07686C3.05529 6.97841 3 6.8449 3 6.70569C3 6.56648 3.05529 6.43297 3.15371 6.33451Z",
    fill: "#F2FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircleicon);
export default __webpack_public_path__ + "static/media/checkcircle.icon.a0b90c6e1789654229bad2e8a90dfedc.svg";
export { ForwardRef as ReactComponent };